import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    base: null,
    bottom: null,
    languages: null,
    moduleTree: null
  },
  mutations: {
    SAVE_BASE(state, base) {
      state.base = base;
    },
    SAVE_BOTTOM(state, bottom) {
      state.bottom = bottom;
    },
    SAVE_LANGUAGES(state, languages) {
      state.languages = languages;
    },
    SAVE_MODULE_TREE(state, moduleTree) {
      state.moduleTree = moduleTree;
    }
  },
  actions: {
    saveBase({ commit }, base) {
      commit("SAVE_BASE", base);
      localStorage.setItem("base", JSON.stringify(base));
    },
    saveBottom({ commit }, bottom) {
      commit("SAVE_BOTTOM", bottom);
      localStorage.setItem("bottom", JSON.stringify(bottom));
    },
    saveLanguages({ commit }, languages) {
      commit("SAVE_LANGUAGES", languages);
    },
    saveModuleTree({ commit }, moduleTree) {
      commit("SAVE_MODULE_TREE", moduleTree);
      localStorage.setItem("moduleTree", JSON.stringify(moduleTree));
    }
  },
  getters: {
    base: state => {
      if (!state.base) {
        return JSON.parse(localStorage.getItem("base"));
      }
      return state.base;
    },
    bottom: state => {
      if (!state.bottom) {
        return JSON.parse(localStorage.getItem("bottom"));
      }
      return state.bottom;
    },
    languages: state => state.languages,
    moduleTree: state => {
      if (!state.moduleTree) {
        return JSON.parse(localStorage.getItem("moduleTree"));
      }
      return state.moduleTree;
    }
  },
  modules: {}
});



// WEBPACK FOOTER //
// ./src/store/index.js